import { getWorkstation } from '@connect-x-app/hybrid-data-access';
import { ApiError, QueryKeys, WorkstationState } from '@connect-x-app/shared-domain-models';
import { useQuery } from '@tanstack/react-query';

export const useGetWorkstation = () =>
  useQuery<WorkstationState[] | null, ApiError, WorkstationState | null>({
    queryFn: getWorkstation,
    queryKey: [QueryKeys.WORKSTATION],
    select: data => data?.[0] ?? null,
    staleTime: 0,
  });
